import { stringFormatter } from '../../../../helpers/i18n';

const values = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
];

const formatters = {
  upto: stringFormatter(__('search.filters.prevOwner.upto')),
};

export default values.map((value) => {
  return {
    value: { max: value },
    label:
      value === '0'
        ? __('search.filters.prevOwner.none')
        : formatters.upto({ value }),
  };
});
